import { config } from "../config";
import { TimeSlot } from "../types/model";

export const baseUrl = `/${config.country}/${config.language}/stores/events`;

export const getCredentialUrl = (url: string) =>
  url.replace("{from}", `from=${window.location.href}`);

export const intlLocale =
  config.intlLocale || `${config.language}-${config.country}`;

export const isRegistrationClosed = (closeDate: number | undefined, now?: Date) => {
  if (!closeDate) {
    return true;
  }
  const closingTime = now ? +now : Date.now();
  return +new Date(closeDate) < closingTime;
};

export const isTimeSlotFullyBooked = (timeSlot: TimeSlot) =>
  timeSlot?.remainingSpots === 0 && !timeSlot?.registerToWaitingList;

export function isObjectEmpty(x: Object) {
  if (!x) {
    return true;
  }

  return Object.keys(x).length === 0;
}

export function getEventIdFromSlug(slug: string) {
  const [name, eventId] = slug.split("--");
  if (!eventId) {
    return name;
  }
  return eventId;
}

export const toTimestamp = (ts: number): number => ts * 1e3;
